/**
 * resource component to display content module information in 
 * list form 
 * 
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as moduleCertificateActions from '../../moduleCertificate/moduleCertificateActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';
import * as userModuleActions from '../../userModule/userModuleActions';

// import global components
import { SearchInput } from '../../../global/components/forms';
import Base from '../../../global/components/BaseComponent.js.jsx';

// import components 
import AgendaTmListItem from '../components/AgendaTmListItem.js.jsx';

// not updating links here because this should no longer be used with london handling agenda

class SingleProgramAgendaManager extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, loggedInUser, study } = this.props;
    dispatch(contentModuleActions.fetchListIfNeeded('study-agenda', study._id))
  }

  render() {
    const {
      match
      , showAll 
      , showOptional
      , sponsor 
      , study 
      , studyUserText
      , contentModuleStore 
    } = this.props;


    const tmList = study && contentModuleStore.lists['study-agenda'] ? contentModuleStore.lists['study-agenda'][study._id] : {};
    const agendaItems = tmList ? tmList.agendaItems : [];

    const optional = _.groupBy(agendaItems, 'optional');

    // 2.10 - ordered courses - NOTE - things can still get a little weird if you mix in multiple expired certs, they will sort to the top and ignore other sorting order because of how this page is structured
    const requiredExpired = optional && optional.false ? optional.false.filter(item => item.certificateStatus === 'expired') : [];
    const requiredExpiringSoon = optional && optional.false ? optional.false.filter(item => item.certificateStatus === 'expiring-soon') : [];
    const requiredPending = optional && optional.false ? optional.false.filter(item => item.certificateStatus === 'pending-attestation') : [];
    const requiredIncomplete = optional && optional.false ? optional.false.filter(item => !item.valid && item.certificateStatus !== 'expiring-soon' && item.certificateStatus !== 'expired' && item.certificateStatus !== 'pending-attestation') : [];
    const requiredComplete = optional && optional.false ? optional.false.filter(item => item.valid && item.certificateStatus !== 'expiring-soon') : [];


    const optionalExpired = optional && optional.true ? optional.true.filter(item => item.certificateStatus === 'expired') : [];
    const optionalExpiringSoon = optional && optional.true ? optional.true.filter(item => item.certificateStatus === 'expiring-soon') : [];
    const optionalPending = optional && optional.true ? optional.true.filter(item => item.certificateStatus === 'pending-attestation') : [];
    const optionalIncomplete = optional && optional.true ? optional.true.filter(item => !item.valid) : [];
    const optionalComplete = optional && optional.true ? optional.true.filter(item => item.valid && item.certificateStatus !== 'expiring-soon') : [];

    
    const isEmpty = (
      !study
      || !study._id
      || !sponsor
      || !sponsor._id
      || !tmList 
      || !requiredExpired
      || !requiredExpiringSoon
      || !requiredPending 
      || !requiredIncomplete
      || !requiredComplete
    );
    
    const isFetching = (
      !tmList 
      || tmList.isFetching 
    )

    return(
      <div>
        <Link to={`/my-agenda`}>
          <h2 className="agenda-link">
            <i className="fa-regular fa-chevron-left fa-2xs" style={{paddingRight: 10}}></i>
            <i className="fa-regular fa-graduation-cap fa-sm" style={{paddingRight: 10}}></i>
            Training
          </h2>
        </Link>
        { showAll ?
          <div className="agenda-header">
            <img className="-logo" style={{marginTop: '20px', marginBottom: '20px'}} src={sponsor.logo}/>
            <div className="-sponsor-top">
              <h2 className="-study-name">{study.name}</h2>
              <p><em>{studyUserText}</em></p>
              {study.showResources ?
                <div className="-link-to-program-resources">
                  <Link  to={match.url + '/resources'}><i className="far fa-file-lines"/> View Resources <i className="far fa-arrow-right"/> </Link>
                </div>
                :
                null 
              }
              
            </div>
          </div>
          :
          <div>
            <div className="-sponsor-top">
              <p className="study-name">{study.name}</p>
              
              { isEmpty ?
                (isFetching ?
                  <p className="-info"><i className="far fa-spinner fa-spin"/> Processing</p>
                  :
                  <p className="-info">n/a</p>
                )
                :
                <p className="-info">
                  { // Check how many of the user's completed modules live within this course 
                    requiredComplete.length + requiredExpiringSoon.length 
                  }
                  <span> of </span>
                  { 
                    optional && optional.false ? optional.false.length : 0
                  } 
                  <span> required modules completed</span>
                </p>  
              }
            </div>
            {study.showResources ?
              <div className="-link-to-program-resources">
                <Link  to={`${match.url}/program/${study.slug}/resources`}><i className="far fa-file-lines"/> View Resources <i className="far fa-arrow-right"/> </Link>
              </div>
              :
              null 
            }
          </div>
        }
        { isEmpty ?
          (isFetching ?
            <div className="u-centerText">
              <div className="loading"></div>
            </div>
          :
            <div className="u-centerText">
              <h2>No simulations were found!</h2>
              <p>Please <Link to="/contact-us">contact</Link> your administrator if you feel this was an error.</p>
              <p>Or navigate to your <Link to="/my-agenda">Programs</Link> to select a specific program!</p>
            </div>
          )
          :
          <div style={{ opacity: isFetching ? 0.5 : 1 }}>
            { !showAll && requiredExpired.length === 0 && requiredExpiringSoon.length === 0 && requiredPending.length === 0 && requiredIncomplete.length === 0 ?
              <div className="-all-caught-up">
                <div className="u-centerText">
                  <div className="-icon">
                    <i className="far fa-check-circle fa-3x"/>
                  </div>
                  <div className="-message">You have completed all required training for this program!</div>
                  <br/>
                  <Link className="yt-btn primary" to={`/my-agenda/program/${study.slug}`}>View all completed & optional training &rarr;</Link>
                </div>
              </div>
              :
              <div className="-agenda-tm-list">
                {/* <p>Expired</p> */}
                { requiredExpired.map((agendaItem, i) => 
                  <AgendaTmListItem
                    agendaItem={agendaItem}
                    key={'reqExp_' + agendaItem._contentModule + '_' +i }
                    contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                  /> 
                )}
                {/* <p>Expiring soon</p>  */}
                { requiredExpiringSoon.map((agendaItem, i) => 
                  <AgendaTmListItem
                    agendaItem={agendaItem}
                    key={'reqExpSoon_' + agendaItem._contentModule + '_' +i }
                    contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                  /> 
                )}
                {/* <p>Pending attestation</p> */}
                { requiredPending.map((agendaItem, i) => 
                  <AgendaTmListItem
                    agendaItem={agendaItem}
                    key={'reqPending_' + agendaItem._contentModule + '_' +i }
                    contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                  /> 
                )}
                {/* <p>Incomplete</p> */}
                { showAll ?
                  <div>
                    {requiredIncomplete.map((agendaItem, i) => 
                      <AgendaTmListItem
                        agendaItem={agendaItem}
                        sponsor={sponsor}
                        key={'reqInc_' + agendaItem._contentModule + '_' +i }
                        contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                      /> 
                    )}
                    { requiredComplete.map((agendaItem, i) => 
                      <AgendaTmListItem
                        agendaItem={agendaItem}
                        sponsor={sponsor}
                        key={'reqComp_' + agendaItem._contentModule + '_' +i }
                        contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                      /> 
                    )}
                  </div>
                  : 
                  <div>
                    {requiredIncomplete.slice(0,5).map((agendaItem, i) => 
                      <AgendaTmListItem
                        agendaItem={agendaItem}
                        sponsor={sponsor}
                        key={'reqInc_' + agendaItem._contentModule + '_' +i }
                        contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                      /> 
                    )}
                  </div>
                }
                <div className="yt-row space-between">
                  { !showAll && requiredIncomplete.length > 5 ?
                    <small>Showing {5 + requiredExpired.length + requiredExpiringSoon.length + requiredPending.length } of {optional && optional.false && optional.false.length } modules</small>
                    :
                    <small>Showing all required training</small>
                  }
                  { !showAll &&
                    <small>
                      <Link to={`/my-agenda/program/${study.slug}`}>View all training for this program</Link>
                    </small>
                  }
                </div>
              </div>
            }
            { showOptional && optional.true && optional.true.length > 0 ? 
              <div className="-study-wrapper">
                <div className="-sponsor-top">
                  <p className="-study-name">Additional Training</p>
                  <p className="-info">
                    { // Check how many of the user's completed modules live within this course 
                      optionalComplete.length 
                    }
                    <span> of </span>
                    { 
                      optional && optional.true ? optional.true.length : 0
                    } 
                    <span> optional modules completed</span>
                  </p>  
                </div>
                
                <div className="-agenda-tm-list">
                  { optionalExpired.map((agendaItem, i) => 
                    <AgendaTmListItem
                      agendaItem={agendaItem}
                      key={'optExp_' + agendaItem._contentModule + '_' +i }
                      contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                    /> 
                  )}
                  {/* <p>Expiring soon</p>  */}
                  { optionalExpiringSoon.map((agendaItem, i) => 
                    <AgendaTmListItem
                      agendaItem={agendaItem}
                      key={'optExpSoon_' + agendaItem._contentModule + '_' +i }
                      contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                    /> 
                  )}
                  {/* <p>Pending attestation</p> */}
                  { optionalPending.map((agendaItem, i) => 
                    <AgendaTmListItem
                      agendaItem={agendaItem}
                      key={'optPending_' + agendaItem._contentModule + '_' +i }
                      contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                    /> 
                  )}
                  { optionalIncomplete.map((agendaItem, i) => 
                    <AgendaTmListItem
                      agendaItem={agendaItem}
                      key={'optInc_' + agendaItem._contentModule + '_' +i }
                      contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                    /> 
                  )}
                  { showAll ? optionalComplete.map((agendaItem, i) => 
                    <AgendaTmListItem
                      agendaItem={agendaItem}
                      key={'optComp_' + agendaItem._contentModule + '_' +i }
                      contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                    /> 
                    )
                    : null 
                  }
                </div>
              </div>
              :
              null
            }
          </div>
        } 
      </div>
    )
  }
}


SingleProgramAgendaManager.propTypes = {
  dispatch: PropTypes.func.isRequired
  , showAll: PropTypes.bool 
  , showOptional: PropTypes.bool 
  , sponsor: PropTypes.object.isRequired 
  , study: PropTypes.object.isRequired 
  , studyUserText: PropTypes.string 
}

SingleProgramAgendaManager.defaultProps = {
  showAll: false 
  , showOptional: false 
  , studyUserText: ''
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    loggedInUser: store.user.loggedIn.user
    , contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleProgramAgendaManager)
);



// WEBPACK FOOTER //
// modules/agenda/views/SingleProgramAgendaManager.js.jsx